import React, { useMemo } from 'react';
import { Column } from '@ant-design/plots';

// Порядок и цвета — те же, что были у .bar-segment в adobe-rating.scss: шкала качества от
// нейтрального серого к акцентным. Заданы hex'ами, а не токенами: график рисуется на canvas,
// до SCSS-переменных ему не дотянуться. Значения сверены с _variables.scss.
const CATEGORIES = [
  { key: 'countOrdinary', name: 'Ordinary', color: '#D0D5DD' },  // $pc-gray-300
  { key: 'countGood',     name: 'Good',     color: '#87A8F2' },  // $pc-accent-500
  { key: 'countStrong',   name: 'Strong',   color: '#C180F9' },  // $sc-violet-500
  { key: 'countTop',      name: 'Top',      color: '#F04438' },  // $pc-error-500
  { key: 'countSuperTop', name: 'SuperTop', color: '#FDB022' },  // $pc-warning-400
];

const AXIS_INK = '#667085';   // $pc-gray-500 — оси подписываем текстовым цветом, не цветом серии

const RatingDistribution = ({ selected = null }) => {
  const data = useMemo(() => {
    if (!selected) return [];

    return CATEGORIES.map(({ key, name }) => ({
      category: name,
      count: Number(selected[key]) || 0,
    }));
  }, [selected]);

  const renderBody = () => {
    if (data.length === 0) {
      return <div className="rating-chart__empty">Select a request to see its distribution</div>;
    }

    return (
      <Column
        data={data}
        xField="category"
        yField="count"
        colorField="category"
        height={260}
        autoFit
        // Категории названы прямо на оси X — легенда дублировала бы их и съедала ширину.
        legend={false}
        scale={{
          // domain задан явно: без него порядок цветов определяется порядком появления в данных,
          // и шкала качества могла бы перекраситься при нулях в начале списка.
          color: {
            domain: CATEGORIES.map((item) => item.name),
            range: CATEGORIES.map((item) => item.color),
          },
          y: { nice: true },
        }}
        axis={{
          x: { title: false, labelFill: AXIS_INK, labelFontSize: 11 },
          y: { title: false, labelFill: AXIS_INK, labelFontSize: 11 },
        }}
        tooltip={{ items: [{ channel: 'y', name: 'Items' }] }}
      />
    );
  };

  return (
    <div className="rating-chart">
      <div className="rating-chart__header">
        <span className="rating-chart__title">Quality distribution</span>
        {selected && (
          <span className="rating-chart__subtitle">
            {selected.keyword} · {selected.total} items
          </span>
        )}
      </div>
      {renderBody()}
    </div>
  );
};

export default RatingDistribution;
